/**
 * Created by Jerker Nord on 2019-12-17.
 */
import {SpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelPartAnimator";
import {Ease, Elastic} from "gsap";
import {BonusBunniesGameConfig} from "../BonusBunniesGameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BonusBunniesGameMode} from "../gamemode/BonusBunniesGameMode";
import {IBonusBunniesGameData} from "../server/data/IBonusBunniesGameData";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";

export class BonusBunniesSpinReelPartAnimator extends SpinReelPartAnimator {

    private _currentMode:string;
    private _nextMode:string;

    constructor(reelId:number) {
        super(reelId);
        this.addEventHandlers();
    }

    private addEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    private onGameDataParsed(data:IBonusBunniesGameData):void {
        this._currentMode = data.mode;
        this._nextMode = data.nextMode;
    }

    protected getSpinStopEase():Ease {
        let config:[number, number] = BonusBunniesGameConfig.instance.REEL_SPIN_STOP_ELASTIC_CONFIG;
        if(this._currentMode == BonusBunniesGameMode.BONUS_GAME) {
            config = BonusBunniesGameConfig.instance.REEL_SPIN_STOP_ELASTIC_CONFIG_BONUS_GAME;
        }

        return Elastic.easeOut.config(config[0], config[1]);
    }
}